import styling from 'components/Templates/components/agenda/RedAgenda/styling';
export default styling;
